// MARK://dhk8/pos/features/shell/ShortcutsDialog
// Keyboard-shortcuts cheat-sheet. '?' toggles it; the rest of the global shortcuts
// (/, g-then-x navigation, Esc-Esc lock) are owned by useShortcuts(). Port of
// sc-restaurant's shell/ShortcutsDialog.tsx onto @dockethub/ui's <Dialog>.

import { Dialog } from '@dockethub/ui'
import { Keyboard } from 'lucide-react'

interface Shortcut { keys: string; label: string }

const SHORTCUTS: Shortcut[] = [
  { keys: '?', label: 'Mostrar / ocultar esta ayuda' },
  { keys: '/', label: 'Buscar (enfoca la caja de búsqueda)' },
  { keys: 'n', label: 'Nueva orden (ir a la comanda)' },
  { keys: 'Esc', label: 'Cerrar diálogo o cancelar acción' },
  { keys: 'Esc Esc', label: 'Bloquear la terminal' },
  { keys: 'F2', label: 'Enviar a cocina (en la comanda)' },
  { keys: 'F9', label: 'Cobrar la orden (en la comanda)' },
  { keys: 'g f', label: 'Ir al plano de mesas' },
  { keys: 'g m', label: 'Ir al menú' },
  { keys: 'g c', label: 'Ir a la comanda' },
  { keys: 'g t', label: 'Ir a tickets' },
  { keys: 'g b', label: 'Ir a la barra (modo rápido)' },
  { keys: 'g k', label: 'Ir a cocina (KDS)' },
  { keys: 'g j', label: 'Ir a caja' },
  { keys: 'g r', label: 'Ir a reportes' },
]

export interface ShortcutsDialogProps {
  open: boolean
  onClose: () => void
}

export default function ShortcutsDialog({ open, onClose }: ShortcutsDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          <Keyboard size={16} /> Atajos de teclado
        </span>
      }
    >
      <table className="dhk8-shortcuts" style={{ width: '100%', borderCollapse: 'collapse', fontVariantNumeric: 'tabular-nums' }}>
        <tbody>
          {SHORTCUTS.map((s) => (
            <tr key={s.keys}>
              <td style={{ padding: '6px 16px 6px 0', whiteSpace: 'nowrap', borderBottom: '1px solid var(--pos-separator)' }}>
                <kbd style={{ border: '1px solid var(--pos-separator)', borderRadius: 'var(--pos-radius-md)', padding: '2px 8px', fontFamily: 'var(--font-mono)', fontSize: '0.85em' }}>
                  {s.keys}
                </kbd>
              </td>
              <td style={{ padding: '6px 0', borderBottom: '1px solid var(--pos-separator)', fontFamily: 'var(--font-sans)' }}>
                {s.label}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Dialog>
  )
}
